<div class="password-rules" aria-live="polite">
  <!-- Resumen: todas las reglas cumplidas -->
  <p class="rules-summary" *ngIf="showSummary">
    <mat-icon class="rule-icon">check_circle</mat-icon>
    <span>Contraseña válida</span>
  </p>

  <!-- Checklist de requisitos -->
  <ng-container *ngIf="!showSummary">
    <p class="rules-title">Tu contraseña debe tener:</p>
    <ul class="rules-list">
      <li
        class="rule"
        *ngFor="let rule of rules; trackBy: trackById"
        [class.met]="rule.met"
      >
        <mat-icon class="rule-icon">{{
          rule.met ? "check_circle" : "radio_button_unchecked"
        }}</mat-icon>
        <span class="rule-label">{{ rule.label }}</span>
      </li>
    </ul>
  </ng-container>
</div>
